import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/root.css';
import 'material-symbols';
import {
    createBrowserRouter,
    RouterProvider,
} from 'react-router-dom';
import Root from './routes/root';
import ErrorPage from './error-page';

const routerReport = createBrowserRouter([
    {
        path: '/',
        element: <Root/>,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <Root />
            },
            {
                path: ':id',
                element: <Root />
            },
        ]
    },
    
    
]);


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)
root.render(
    <React.StrictMode>
        
        <RouterProvider router={routerReport} />
        
    </React.StrictMode>
)
